import { render, staticRenderFns } from "./barHeader.vue?vue&type=template&id=04931894&scoped=true&"
import script from "./barHeader.vue?vue&type=script&lang=js&"
export * from "./barHeader.vue?vue&type=script&lang=js&"
import style0 from "./barHeader.vue?vue&type=style&index=0&id=04931894&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04931894",
  null
  
)

component.options.__file = "barHeader.vue"
export default component.exports